export default __webpack_public_path__ + "static/media/advancly.f6596a27.png";